import React, { FC } from "react";
import styled from "styled-components";
import { media } from "../../styles/global/theme";

import { ReactComponent as LogoSVG } from "../../media/PeachPaymentsLogoHorizontalIcon.svg";

export const Wrapper = styled.div`
  width: 100%;
  max-width: 230px;
  margin: auto;
  text-align: center;

  svg {
    width: 100%;
    height: auto;
  }

  ${media.greaterThan("md")`
    max-width: 320px;
  `}
`;

const Logo: FC = () => (
  <Wrapper>
    <LogoSVG />
  </Wrapper>
);

export default Logo;
